import React from 'react'
import { Plus } from 'react-feather'

/**
 * Traditonal <a> tag with <ALink /> styling
 *
 * @param {slug} link
 * @param {text} string
 */
export const TradLink = ({ href, text }) => {
  return (
    <a target="_blank" rel="noreferrer" className="Card_Link" href={href}>
      <Plus size={22} />
      <span>{text}</span>
    </a>
  )
}

export default TradLink
